import { createAction } from '@reduxjs/toolkit';

export const requestAddMemberToTeam = createAction('team-member/addMemberToTeam');
export const requestRemoveMemberFromTeam = createAction('team-member/removeMemberFromTeam');
